export const initUtilmenu = () => {
    const li_level1_items = document.querySelectorAll('.utilmenu__li--level-1')

    li_level1_items.forEach((item) => {
        item.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                e.stopPropagation()
                e.preventDefault()

                const li_open = document.querySelector('li.is-open')

                if (li_open && li_open !== item) {
                    li_open.classList.remove('is-open')
                }

                item.classList.toggle('is-open')
                document.body.classList.toggle('no-scroll')
            }
        })
    })
}
